import React, { useState, useEffect } from 'react'
import { Modal, Form, Button, } from "react-bootstrap"
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { NavLink, Link, useNavigate } from 'react-router-dom'
import Assets from '../../constants/images'
import { Times, LogoutFill, DeleteAccountFill, RecentActivityFill, StatsBarFill, BlockUserFill, SettingFill, BellFill, LockFill, TermsAndConditionFill, PrivacyFill, EyeFill } from '../../constants/svgs'
import DeleteAccountPopup from "../popup/DeleteAccountPopup"
import LogoutPopup from './LogoutPopup'

const BrandProfilePopup = ({ profilePopup, setProfilePopup }) => {
    const navigate = useNavigate()
    const [deleteAccountPopup, setDeleteAccountPopup] = useState(false)
    const [logoutPopup, setLogoutPopup] = useState(false)

    useEffect(() => {
        setProfilePopup(false)
    }, [navigate])

    return (
        <>
            <DeleteAccountPopup deleteAccountPopup={deleteAccountPopup} setDeleteAccountPopup={setDeleteAccountPopup} />
            <LogoutPopup logoutPopup={logoutPopup} setLogoutPopup={setLogoutPopup} />

            <Modal
                className='theme-popup profile-popup'
                show={profilePopup}
                onHide={() => setProfilePopup(false)}
                size="md"
                centered
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Body>
                    <div className="wrapper">
                        <div className='text-center d-flex align-items-center mb-30 pb-30 border-bottom'>
                            <h3 className='w-100 d-inline-block'>MY PROFILE</h3>
                            <div className='times-icon text-end' onClick={() => setProfilePopup(false)}>
                                <Times />
                            </div>
                        </div>

                        <div className='content-container text-center'>
                            <div className="profile-wrapper mx-auto">
                                <img src={Assets.BrandAvatarLarge2} alt="" onError={e=> e.target.src = Assets.ProfilePlaceholder} />
                            </div>
                            <div className='mt-2'>
                                <h2>Anny Kings</h2>
                                <span className="d-block">Toronto, Canada</span>
                                <span className="d-block">Clothing</span>
                                <span className="d-block">support@abcstore.com</span>
                                <span className="d-block">www.abcstore.com</span>
                            </div>
                            <div className="mt-20 mb-20">
                                <NavLink to="/my-profile">View Profile</NavLink>
                            </div>
                        </div>

                        <div className='link-container'>
                            <ul>
                                <li className='mt-2 mb-2 pb-2 border-top pt-2 border-bottom'>
                                    <NavLink to="/edit-profile">
                                        <div className="d-flex align-items-center">
                                            <div className="icon-wrapper me-3">
                                                <BellFill />
                                            </div>

                                            <div>
                                                <span>Edit Profile</span>
                                            </div>
                                        </div>
                                    </NavLink>
                                </li>

                                <li className='mt-2 mb-2 pb-2 border-bottom d-none d-md-block'>
                                    <NavLink to="/settings/change-password">
                                        <div className="d-flex align-items-center">
                                            <div className="icon-wrapper me-3">
                                                <SettingFill />
                                            </div>

                                            <div>
                                                <span>Settings</span>
                                            </div>
                                        </div>
                                    </NavLink>
                                </li>

                                <li className='mt-2 mb-2 pb-2 border-bottom'>
                                    <NavLink to="/blocked-users">
                                        <div className="d-flex align-items-center">
                                            <div className="icon-wrapper me-3">
                                                <BlockUserFill />
                                            </div>

                                            <div>
                                                <span>Blocked Users</span>
                                            </div>
                                        </div>
                                    </NavLink>
                                </li>

                                <li className='mt-2 mb-2 pb-2 border-bottom'>
                                    <NavLink to="/statistics-and-analytics">
                                        <div className="d-flex align-items-center">
                                            <div className="icon-wrapper me-3">
                                                <StatsBarFill />
                                            </div>

                                            <div>
                                                <span>Demographics</span>
                                            </div>
                                        </div>
                                    </NavLink>
                                </li>


                                <div className="d-block d-md-none">
                                    <li className='mt-2 mb-2 pb-2 border-bottom'>
                                        <NavLink to="/settings/change-password">
                                            <div className="d-flex align-items-center">
                                                <div className="icon-wrapper me-3">
                                                    <LockFill />
                                                </div>

                                                <div>
                                                    <span>Change Password</span>
                                                </div>
                                            </div>
                                        </NavLink>
                                    </li>

                                    <li className='mt-2 mb-2 pb-2 border-bottom'>
                                        <NavLink to="/settings/terms-and-conditions">
                                            <div className="d-flex align-items-center">
                                                <div className="icon-wrapper me-3">
                                                    <TermsAndConditionFill />
                                                </div>

                                                <div>
                                                    <span>Terms And Conditions</span>
                                                </div>
                                            </div>
                                        </NavLink>
                                    </li>

                                    <li className='mt-2 mb-2 pb-2 border-bottom'>
                                        <NavLink to="/settings/privacy-policy">
                                            <div className="d-flex align-items-center">
                                                <div className="icon-wrapper me-3">
                                                    <PrivacyFill />
                                                </div>

                                                <div>
                                                    <span>Privacy Policy</span>
                                                </div>
                                            </div>
                                        </NavLink>
                                    </li>

                                    <li className='mt-2 mb-2 pb-2 border-bottom'>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center">
                                                <div className="icon-wrapper me-3">
                                                    <EyeFill />
                                                </div>
                                                <div className=''>
                                                    <span className='d-inline-block'>Privacy <span className='w-300'>(Public/Private)</span></span>
                                                </div>
                                            </div>

                                            <div className='text-end'>
                                                <Form.Check
                                                    className="p-0"
                                                    type="switch"
                                                    id="custom-switch"
                                                />
                                            </div>
                                        </div>
                                    </li>
                                </div>

                                <li className='mt-2 cursor mb-2 pb-2 border-bottom'>
                                    <div className="d-flex align-items-center"
                                        onClick={() => {
                                            setProfilePopup(false)
                                            setDeleteAccountPopup(true)
                                        }}
                                    >
                                        <div className="icon-wrapper me-3">
                                            <DeleteAccountFill />
                                        </div>

                                        <div>
                                            <span>Delete Account</span>
                                        </div>
                                    </div>
                                </li>

                                <li className='mt-2 cursor pb-2 border-bottom'>
                                    <div className="d-flex align-items-center"
                                        onClick={() => {
                                            setProfilePopup(false)
                                            setLogoutPopup(true)
                                        }}
                                    >
                                        <div className="icon-wrapper me-3">
                                            <LogoutFill />
                                        </div>

                                        <div>
                                            <span>Logout</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default BrandProfilePopup